module.exports = __webpack_public_path__ + "static/img/cloud_assi.bd87392.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/cloud_assi.png
// module id = tNLZ
// module chunks = 0